import { Box, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'

export default function Bloque7({ text9, handleDatosTextField9 }) {


    useEffect(()=>{
        console.log(text9)
    }, [text9])

    return (
        <div>
            <Box style={{ marginTop: "15px" }} >
                <Typography style={{ marginBottom: "20px" }} variant="h4" >Tratamiento / Evolución</Typography>

                {
                    text9.map(x =>
                        <Grid container>
                            <Grid lg={12}>
                                <Box>
                                    <TextField
                                        required
                                        style={{ marginTop: "20px" }}
                                        label={x.label}
                                        multiline
                                        fullWidth
                                        rows={7}
                                        onChange={(e) => handleDatosTextField9(x.id, e.target.value, 'valor')}
                                        value={x.valor}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    )
                }
            </Box>
        </div>
    )
}
